import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";

const msg = (e) => e?.response?.data?.detail?.message || "Could not load the report.";
const BTN = "min-h-[44px] px-4 rounded-sm text-sm font-semibold border border-erf-borderCream";

// B7: weekly progress report from real records only; each line says how many records it cites. Sharing follows the Phase 6 rules (client email off by default).
export default function ProgressReport() {
  const { pid } = useParams();
  const [r, setR] = useState(null);
  const [note, setNote] = useState("");
  useEffect(() => { api.get(`/pm/projects/${pid}/progress-report`).then((x) => setR(x.data)).catch((e) => setNote(msg(e))); }, [pid]);
  const pdf = async () => {
    const x = await api.get(`/pm/projects/${pid}/progress-report/pdf`, { responseType: "blob" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(x.data); a.download = `progress-${r.week_start}.pdf`; a.click();
  };
  const share = () => api.post(`/pm/projects/${pid}/progress-report/share`).then((x) => setNote(x.data.message)).catch((e) => setNote(msg(e)));
  return (
    <AppShell title="Weekly progress report" subtitle="Assembled from the project's own records">
      <div className="mx-auto w-full max-w-[800px] px-4 md:px-6 space-y-3" data-testid="pm-report">
        {note && <p role="status" className="text-sm" data-testid="pm-report-note">{note}</p>}
        {r && (
          <>
            <p className="text-sm" data-testid="pm-report-week">Week {r.week_start} to {r.week_end}</p>
            <ul className="space-y-2">
              {r.lines.map((ln) => (
                <li key={ln.key} className="border border-erf-borderCream rounded bg-white p-3 text-sm" data-testid={`pm-report-line-${ln.key}`}>
                  {ln.text} <span className="text-xs text-erf-dark/60">({ln.record_ids.length} record{ln.record_ids.length === 1 ? "" : "s"} cited)</span>
                </li>
              ))}
              <li className="border border-erf-borderCream rounded bg-erf-creamSecondary p-3 text-sm" data-testid="pm-report-budget">{r.budget.text}</li>
            </ul>
            <div className="flex flex-wrap gap-2">
              <button type="button" onClick={() => pdf().catch((e) => setNote(msg(e)))} className={`${BTN} bg-erf-dark text-white`} data-testid="pm-report-pdf">Download PDF</button>
              <button type="button" onClick={share} className={BTN} data-testid="pm-report-share">Share with client</button>
            </div>
          </>
        )}
      </div>
    </AppShell>
  );
}
